import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight } from 'lucide-react';
export function OfferPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show popup after scrolling down ~400px
      if (window.scrollY > 400 && !isDismissed) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);
  const handleClose = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-175">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-8 left-8 z-50 hidden md:block w-80 bg-slate-900 border border-brand-accent/30 rounded-2xl shadow-2xl shadow-brand-accent/10 overflow-hidden" data-id="element-176">
          <div className="p-6 relative" data-id="element-177">
            <button onClick={handleClose} className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors" aria-label="Close offer" data-id="element-178">
              <X className="w-5 h-5" data-id="element-179" />
            </button>

            <h4 className="text-white font-serif font-bold text-xl mb-5 pr-6 leading-tight" data-id="element-180">
              Need Help Reaching Overdue Patients?
            </h4>

            {/* Primary Offer */}
            <div className="mb-5" data-id="element-181">
              <h5 className="text-brand-accent font-bold text-lg mb-1 flex items-center gap-2" data-id="element-182">
                Pay Per Booking
              </h5>
              <p className="text-slate-300 text-sm mb-4 leading-relaxed" data-id="element-183">
                Pay as we book your overdue patients.
              </p>
              <a href="#book-call" onClick={handleClose} className="w-full bg-brand-accent text-brand-dark font-bold py-2.5 rounded-xl text-sm hover:bg-white transition-colors flex items-center justify-center gap-2" data-id="element-184">
                Get Started <ArrowRight className="w-4 h-4" data-id="element-185" />
              </a>
            </div>

            <div className="h-px w-full bg-white/10 my-5" data-id="element-186" />

            {/* Secondary Offer */}
            <div data-id="element-187">
              <h5 className="text-white font-bold text-sm mb-1" data-id="element-188">
                Patient Coordination – $399
              </h5>
              <p className="text-slate-400 text-xs mb-3" data-id="element-189">
                Inbound & Outbound Call Management
              </p>
              <a href="#scale-business" onClick={handleClose} className="block text-center w-full bg-white/5 border border-white/10 text-white font-bold py-2 rounded-xl text-xs hover:bg-white/10 transition-colors" data-id="element-190">
                Learn More
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}